import React from 'react'
import Loader from 'react-loader-spinner'

const LoadingWithText = ({ text }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <p>{text}</p>
                <Loader type="ThreeDots" color="#28ff65"></Loader>
            </div>
        </>
    )
}

export default LoadingWithText
